<template>
  <div class="divider">
    <svg class="bg-primary-alt" width="100%" height="100%" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="none">
      <path d="M0,0 C6.83050094,50 15.1638343,75 25,75 C41.4957514,75 62.4956597,0 81.2456597,0 C93.7456597,0 99.9971065,0 100,0 L100,100 L0,100" :fill="background === 'light' ? '#F8F9FA' : '#343A40'"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'divider',
  props: {
    background: { type: String, default: 'dark' }
  }
}
</script>

<style scoped>
.divider:not(:first-child) {
  top: 1px;
}

.divider {
  margin-top: 1rem;
  position: relative;
  max-height: 75px;
}

.divider svg {
    background: none !important;
    height: 6vw;
}

.bg-primary-alt {
  background: transparent;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}
</style>
